"use client";

import styles from './_patient-satisfaction-modal.module.scss';

export default function HcpClinicalInformationPatientSatisfactionModal() {
  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <h2 id="patient-satisfaction-modal-heading" className={styles.heading}>
          Patient satisfaction with CRENESSITY<sup>1</sup>
        </h2>
        <p className={styles.subtitle}>
          In a survey of 48 adults and 29 caregivers, when asked at the end of the open-label extension period<sup>1</sup>:
        </p>
      </div>

      <div className={styles.cards_grid}>
        <div className={`${styles.card} ${styles.card_eggplant}`}>
          <p>
            <strong>96% of adults and 93% of caregivers of children </strong>
            prefer a treatment plan <span className="mobile:text-nowrap">with CRENESSITY</span> over one <span className="mobile:text-nowrap">without CRENESSITY.</span><sup>1*</sup>
          </p>
        </div>
        <div className={`${styles.card} ${styles.card_tangerine}`}>
          <p>
            <strong>96% of adults and 100% of caregivers of children </strong>
            were satisfied with taking CRENESSITY.<sup>1†</sup>
          </p>
        </div>
        <div className={`${styles.card} ${styles.card_eggplant}`}>
          <p>
            <strong>96% of adults and 96% of caregivers of children </strong>
            wished they or their child could have started CRENESSITY at a <span className="mobile:text-nowrap">younger age.<sup>1‡</sup></span>
          </p>
        </div>
        <div className={`${styles.card} ${styles.card_tangerine}`}>
          <p>
            <strong>98% of adults and 100% of caregivers of children </strong>
            would recommend CRENESSITY to others with classic CAH.<sup>1§</sup>
          </p>
        </div>
      </div>

      <div className={styles.footnotes}>
        <div className={styles.footnote_row}>
          <span className={styles.footnote_symbol}>*</span>
          <p>Percentages include adult participants and caregivers of pediatric participants from the CAHtalyst<sup>®</sup> trials who &ldquo;agreed&rdquo; or &ldquo;strongly agreed&rdquo; that they prefer treatment with CRENESSITY over a treatment plan without CRENESSITY in the final treatment satisfaction survey.<sup>1</sup></p>
        </div>
        <div className={styles.footnote_row}>
          <span className={styles.footnote_symbol}>†</span>
          <p>Percentages include adult participants and caregivers of pediatric participants from the CAHtalyst<sup>®</sup> trials who rated their level of satisfaction with CRENESSITY as either &ldquo;moderately satisfied&rdquo; or &ldquo;greatly satisfied&rdquo; in the final treatment satisfaction survey.<sup>1</sup></p>
        </div>
        <div className={styles.footnote_row}>
          <span className={styles.footnote_symbol}>‡</span>
          <p>Percentages include adult participants and caregivers of pediatric participants from the CAHtalyst<sup>®</sup> trials who &ldquo;agreed&rdquo; or &ldquo;strongly agreed&rdquo; to the statement, &ldquo;I wish I/my child could have started CRENESSITY at a younger age,&rdquo; in the final treatment satisfaction survey.<sup>1</sup></p>
        </div>
        <div className={styles.footnote_row}>
          <span className={styles.footnote_symbol}>§</span>
          <p>Percentages include adult participants and caregivers of pediatric participants from the CAHtalyst<sup>®</sup> trials who &ldquo;agreed&rdquo; or &ldquo;strongly agreed&rdquo; with the statement, &ldquo;I would recommend CRENESSITY to another person/caregiver of a person with classic CAH,&rdquo; in the final treatment satisfaction survey.<sup>1</sup></p>
        </div>
      </div>

      <div className={styles.reference}>
        <p className={styles.reference_label}>REFERENCE</p>
        <div className={styles.footnote_row}>
          <span className={`${styles.footnote_symbol} ${styles.footnote_symbol_num}`}>1.</span>
          <p>Vaid S, Abramowitz J, Bancos I, et al. A cross-sectional survey on crinecerfont and quality of life of adults with classic congenital adrenal hyperplasia in the United States participating in CAHtalyst<sup>®</sup> adult and pediatric open-label extension. Presented at: The Endocrine Society Annual Meeting; June 13-16, 2026; Chicago, IL.</p>
        </div>
      </div>
    </section>
  );
}
